import * as React from 'react';

type SkillPathwayActivelyEnrollingContextType = {
  currentEnrollingAction: string | undefined;
  setCurrentEnrollingAction: (action: string | undefined) => void;
};

const SkillPathwayActivelyEnrollingContext = React.createContext<SkillPathwayActivelyEnrollingContextType | undefined>(
  undefined
);

type SkillPathwayActivelyEnrollingProviderProps = React.PropsWithChildren<{}>;

export const SkillPathwayActivelyEnrollingProvider = ({ children }: SkillPathwayActivelyEnrollingProviderProps) => {
  const [currentEnrollingAction, setCurrentEnrollingAction] = React.useState<string | undefined>(undefined);

  const value = React.useMemo(
    () => ({
      currentEnrollingAction,
      setCurrentEnrollingAction,
    }),
    [currentEnrollingAction]
  );

  return (
    <SkillPathwayActivelyEnrollingContext.Provider value={value}>
      {children}
    </SkillPathwayActivelyEnrollingContext.Provider>
  );
};

export const getEnrollingCourseActionId = (courseId: string) => {
  return `pathway-${courseId}`;
};

export const getEnrollingCourseAssessmentActionId = (courseId: string) => {
  return `pathway-${courseId}-assessment`;
};

export const getEnrollingHeroActionId = () => {
  return 'pathway-hero-enroll';
};

export const shouldDisableActionButton = (enrollingActionId: string, currentEnrollingActionId?: string) => {
  return !!currentEnrollingActionId && currentEnrollingActionId !== enrollingActionId;
};

// On skill pathway page, we provide buttons that activate enrollment in the main hero and in each course action section in the syllabus.
// This context is used to track the currently active enrollment action and disable buttons that are not related to the currently active action,
// in order to prevent multiple enrollments into the pathway happening at the same time.
export const useSkillPathwayActivelyEnrolling = () => {
  const context = React.useContext(SkillPathwayActivelyEnrollingContext);
  if (context === undefined) {
    throw new Error('useSkillPathwayActivelyEnrolling must be used within a SkillPathwayActivelyEnrollingProvider');
  }
  return context;
};

export default SkillPathwayActivelyEnrollingContext;
